import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError, change } from 'redux-form';
import { dateFormat, toFromDates, getFromToDates, } from '../components/Common/cleanDates';

import {
    REQUEST_AR,
    FETCH_AR_SUCCESS,
    FETCH_AR_FAILURE,
    CREATE_AR,
    CREATE_AR_SUCCESS,
    CREATE_AR_FAILURE,
    REFUND_AR,
    REFUND_AR_SUCCESS,
    REFUND_AR_FAILURE,
    EDIT_AR,
    EDIT_AR_SUCCESS,
    EDIT_AR_FAILURE,
    DELETE_AR,
    DELETE_AR_SUCCESS,
    DELETE_AR_FAILURE,
    REQUEST_AR_DETAIL,
    FETCH_AR_DETAIL_SUCCESS,
    FETCH_AR_DETAIL_FAILURE,
    CLEAR_AR_DETAIL,
    REQUEST_INVOICES,
    FETCH_INVOICES_SUCCESS,
    FETCH_INVOICES_FAILURE,
    REQUEST_CREDITS,
    FETCH_CREDITS_SUCCESS,
    FETCH_CREDITS_FAILURE,
    CLEAR_CREDITS,
    REQUEST_AR_ACCOUNTS,
    FETCH_AR_ACCOUNTS_SUCCESS,
    FETCH_AR_ACCOUNTS_FAILURE,
    CLEAR_AR_ACCOUNTS,
    CLEAR_AR_FORM,
    BOUNCE_CHECK,
    BOUNCE_CHECK_SUCCESS,
    BOUNCE_CHECK_FAILURE,

    REQUEST_AP,
    FETCH_AP_SUCCESS,
    FETCH_AP_FAILURE,
    CREATE_AP,
    CREATE_AP_SUCCESS,
    CREATE_AP_FAILURE,
    EDIT_AP,
    EDIT_AP_SUCCESS,
    EDIT_AP_FAILURE,
    DELETE_AP,
    DELETE_AP_SUCCESS,
    DELETE_AP_FAILURE,
    REQUEST_AP_DETAIL,
    FETCH_AP_DETAIL_SUCCESS,
    FETCH_AP_DETAIL_FAILURE,
    CLEAR_AP_DETAIL,
    CLEAR_AP_FORM,

    REQUEST_STATEMENT,
    FETCH_STATEMENT_SUCCESS,
    FETCH_STATEMENT_FAILURE,
    REQUEST_STATEMENT_AP,
    FETCH_STATEMENT_AP_SUCCESS,
    FETCH_STATEMENT_AP_FAILURE,
    REQUEST_GENERAL_REPORT,
    FETCH_GENERAL_REPORT_SUCCESS,
    FETCH_GENERAL_REPORT_FAILURE,
    REQUEST_CITY_REPORT,
    FETCH_CITY_REPORT_SUCCESS,
    FETCH_CITY_REPORT_FAILURE,
    RESET_CITY_REPORT,
    RESET_CURRENT_TYPE_RADIO,
    REQUEST_CUSTOMER_STATEMENT,
    FETCH_CUSTOMER_STATEMENT_SUCCESS,
    FETCH_CUSTOMER_STATEMENT_FAILURE,
    REQUEST_VENDOR_STATEMENT,
    FETCH_VENDOR_STATEMENT_SUCCESS,
    FETCH_VENDOR_STATEMENT_FAILURE,
    REQUEST_CUSTOMER_STATEMENT_LIST,
    FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS,
    FETCH_CUSTOMER_STATEMENT_LIST_FAILURE,
    REQUEST_VENDOR_STATEMENT_LIST,
    FETCH_VENDOR_STATEMENT_LIST_SUCCESS,
    FETCH_VENDOR_STATEMENT_LIST_FAILURE,
    REQUEST_MOBILE_CUSTOMER_STATEMENT,
    FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS,
    FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE,
    RESET_MOBILE_CUSTOMER_STATEMENT,
} from './type';

import {
    AR_URL,
    AP_URL
} from './url';

import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isGGI, isLAP } from '../actions/root_url';
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';

import { DEFAULT_ERROR } from '../components/Common/constants';

export function fetchAR(fromDate, toDate, days) {
    const dates = toFromDates(days, fromDate, toDate);
    fromDate = "PaymentDate__gte=" + dates.fromDate + "&";
    toDate = "PaymentDate__lte=" + dates.toDate;
    return dispatch => {
        dispatch({type: REQUEST_AR});
        return axios.get(AR_URL + 'payment/?' + fromDate + toDate,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchARSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchARFailure(err));
              }
            });
    }
}

export function fetchARSuccess(response) {
    return {
        type: FETCH_AR_SUCCESS,
        payload: response
    }
}

export function fetchARFailure(response) {
  return {
      type: FETCH_AR_FAILURE,
      payload: response
  }
}

export function createAR({
  Customer,
  TotalPayment,
  PaymentDate,
  PenaltyAmount,
  Method,
  CheckNum,
  Credits,
  Account,
  AccountName,
  Discount,
  DiscountedAmount,
  Waive,
  WaiveAmount,
  TotalAmount,
  Note
}, Invoices) {
    if(Customer)
      Customer = Customer.value || Customer;
    if(Account)
      Account = Account.value || Account;
    if(Method)
      Method = Method.value || Method;
    return dispatch => {
        dispatch({type: CREATE_AR});
        return axios.post(AR_URL + 'payment/',
            {
                Customer,
                TotalPayment,
                PaymentDate,
                PenaltyAmount,
                Method,
                CheckNum,
                Credits,
                Account,
                AccountName,
                Discount,
                Waive,
                WaiveAmount,
                TotalAmount,
                DiscountedAmount,
                Note,
                Invoices
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createARSuccess(response));
              browserHistory.push('/AR');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(createARFailure(err));
              }
            });
    }
}

export function createARSuccess(response) {
    return {
        type: CREATE_AR_SUCCESS,
        payload: response
    }
}

export function createARFailure(response) {
  return {
      type: CREATE_AR_FAILURE,
      payload: response
  }
}

export function editAR({
  Customer,
  Payment_id,
  PaymentDate,
  PenaltyAmount,
  TotalPayment,
  Method,
  CheckNum,
  Account,
  AccountName,
  Discount,
  DiscountedAmount,
  Note,
  Waive,
  WaiveAmount,
  TotalAmount,
  }, Invoices
) {
    if(Customer)
      Customer = Customer.value || Customer;
    if(Account)
      Account = Account.value || Account;
    if(Method)
      Method = Method.value || Method;
    return dispatch => {
        dispatch({type: EDIT_AR});
        return axios.put(`${AR_URL}payment/${Payment_id}`,
            {
              Customer,
              PaymentDate,
              TotalPayment,
              PenaltyAmount,
              Method,
              CheckNum,
              Account,
              AccountName,
              Discount,
              DiscountedAmount,
              Note,
              Waive,
              WaiveAmount,
              TotalAmount,
              Invoices,
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editARSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(editARFailure(err));
              }
            });

    }
}

export function editARSuccess(response) {
    return {
        type: EDIT_AR_SUCCESS,
        payload: response
    }
}

export function editARFailure(response) {
  return {
      type: EDIT_AR_FAILURE,
      payload: response
  }
}

export function deleteAR(Payment_id) {
  return dispatch => {
      dispatch({type: DELETE_AR});
      return axios.delete(AR_URL + 'payment/' + Payment_id,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(deleteARSuccess(response));
            browserHistory.push('/AR');
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(deleteARFailure(err));
            }
          });
  }
}

function deleteARSuccess(response) {
  return {
    type: DELETE_AR_SUCCESS,
    payload: response
  }
}

function deleteARFailure(response) {
  return {
    type: DELETE_AR_FAILURE,
    payload: response
  }
}

export function refundARSuccess(response) {
  return {
    type: REFUND_AR_SUCCESS,
    payload: response,
  };
}

export function refundARFailure(response) {
  return {
    type: REFUND_AR_FAILURE,
    payload: response,
  };
}


export const changeField = (field, value, form) => dispatch => (
  dispatch(change(form, field, value))
);
/*
*@refundProps - { Account, Customer, TotalPayment, PaymentDate, Method, CheckNum }
*@Invoices - List of invoices in the right table of CreateAR
*/
export function refundAR(refundProps, Invoices) {
  const { PaymentDate, TotalPayment, CheckNum } = refundProps;
  const Customer = (refundProps.Customer) ? refundProps.Customer.value || refundProps.Customer : null;
  const Account = (refundProps.Account) ? refundProps.Account.value || refundProps.Account : null;
  const Method = (refundProps.Method) ? refundProps.Method.value || refundProps.Method : null;
  return (dispatch) => {
    dispatch({ type: REFUND_AR });
    return axios({
      method: 'post',
      url: `${AR_URL}refund/`,
      data: {
        Customer,
        TotalPayment,
        PaymentDate,
        Method,
        CheckNum,
        Account,
        Invoices,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(refundARSuccess(response));
        browserHistory.push('/AR');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(refundARFailure(err));
        }
      });
  };
}

/* id: AR payment_id */
export function bounceCheck(id) {
  const token = localStorage.getItem('token');
  return dispatch => {
      dispatch({ type: BOUNCE_CHECK });
      return axios({
        method: 'post',
        url: `${AR_URL}bounce/${id}`,
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => {
        dispatch(bounceCheckSuccess(response));
        browserHistory.push('/AR');
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(bounceCheckFailure(err));
        }
      });
  };
}

function bounceCheckSuccess(response) {
  return {
    type: BOUNCE_CHECK_SUCCESS,
    payload: response,
  };
}

function bounceCheckFailure(response) {
  return {
    type: BOUNCE_CHECK_FAILURE,
    payload: response,
  };
}

export function fetchARInvoices(customer_id, invoiceDate, fromDate, toDate) {
    const dates = toFromDates(-1, fromDate, toDate)
    if(invoiceDate == "range" && fromDate) {
      fromDate = "PostingDate__gte=" + dates.fromDate + "&";
    }
    else {
      fromDate = ""
    }
    if(invoiceDate == "range" && toDate) {
      toDate = "PostingDate__lte=" + dates.toDate + "&";
    }
    else {
      toDate = ""
    }
    customer_id = "Deliver_Customer_id=" + customer_id;
    return dispatch => {
        dispatch({type: REQUEST_INVOICES});
        return axios.get(AR_URL + 'invoices/?' + fromDate + toDate + customer_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchInvoicesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchInvoicesFailure(err));
              }
            });
    }
}

export function fetchInvoicesSuccess(response) {
    return {
        type: FETCH_INVOICES_SUCCESS,
        payload: response
    }
}

export function fetchInvoicesFailure(response) {
  return {
      type: FETCH_INVOICES_FAILURE,
      payload: response
  }
}

export function fetchARCredits(customer_id) {
  return dispatch => {
      dispatch({type: REQUEST_CREDITS});
      return axios.get(AR_URL + 'credits/' + customer_id,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(fetchCreditsSuccess(response));
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(fetchCreditsFailure(err));
            }
          });
  }
}

export function fetchCreditsSuccess(data) {
  return {
    type: FETCH_CREDITS_SUCCESS,
    payload: data
  }
}

export function fetchCreditsFailure(error) {
  return {
    type: FETCH_CREDITS_FAILURE,
    payload: error
  }
}

export function clearCredits() {
  return {
    type: CLEAR_CREDITS
  }
}

export function fetchARAccounts() {
  const token = localStorage.getItem('token');
  return dispatch => {
      dispatch({ type: REQUEST_AR_ACCOUNTS });
      return axios({
        method: 'get',
        url: `${AR_URL}accounts/`,
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => {
        dispatch(fetchAccountsSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchAccountsFailure(err));
        }
      });
  };
}

export function fetchAccountsSuccess(data) {
  return {
    type: FETCH_AR_ACCOUNTS_SUCCESS,
    payload: data
  };
}

export function fetchAccountsFailure(error) {
  return {
    type: FETCH_AR_ACCOUNTS_FAILURE,
    payload: error
  };
}

export function clearARAccounts() {
  return {
    type: CLEAR_AR_ACCOUNTS
  };
}

export function fetchARDetail(checkID) {
    return dispatch => {
        dispatch({type: REQUEST_AR_DETAIL});
        return axios.get(AR_URL + 'payment/' + checkID,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchARDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchARDetailFailure(err));
              }
            });
    }
}

export function fetchARDetailSuccess(response) {
    return {
        type: FETCH_AR_DETAIL_SUCCESS,
        payload: response
    }
}

export function fetchARDetailFailure(response) {
  return {
      type: FETCH_AR_DETAIL_FAILURE,
      payload: response
  }
}

export function clearARDetail() {
  return {
    type: CLEAR_AR_DETAIL,
  }
}

export function clearARForm() {
  return {
    type: CLEAR_AR_FORM,
  };
}

export function fetchAP(fromDate, toDate, days) {
    const dates = toFromDates(days, fromDate, toDate);
    fromDate = "PaymentDate__gte=" + dates.fromDate + "&";
    toDate = "PaymentDate__lte=" + dates.toDate;
    return dispatch => {
        dispatch({type: REQUEST_AP});
        return axios.get(AP_URL + 'payment/?' + fromDate + toDate,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchAPSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchAPFailure(err));
              }
            });

    }
}

export function fetchAPSuccess(response) {
    return {
        type: FETCH_AP_SUCCESS,
        payload: response
    }
}

export function fetchAPFailure(response) {
  return {
      type: FETCH_AP_FAILURE,
      payload: response
  }
}

export function createAP({
  Vendor,
  TotalPayment,
  PaymentDate,
  Method,
  CheckNum,
  Credits,
  Account,
  AccountName,
  Discount,
  Note,
  WaiveAmount,
}, Invoices) {
    if(Vendor)
      Vendor = Vendor.value || Vendor;
    if(Account)
      Account = Account.value || Account;
    if(Method)
      Method = Method.value || Method;
    return dispatch => {
        dispatch({type: CREATE_AP});
        return axios.post(AP_URL + 'payment/',
            {
                Vendor,
                TotalPayment,
                PaymentDate,
                Method,
                CheckNum,
                Credits,
                Account,
                AccountName,
                Discount,
                WaiveAmount,
                Note,
                Invoices
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createAPSuccess(response));
              browserHistory.push('/AP');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(createAPFailure(err));
              }
            });
    }
}

export function createAPSuccess(response) {
    return {
        type: CREATE_AP_SUCCESS,
        payload: response
    }
}

export function createAPFailure(response) {
  return {
      type: CREATE_AP_FAILURE,
      payload: response
  }
}

export function editAP({
  TotalPayment,
  Method,
  PostingDate,
  PaymentDate,
  PaymentID,
  CheckNum,
  WaiveAmount,
  Discount,
  Account,
  AccountName,
  Credits,
  Note,
  }, Invoices
) {
    if (Credits) {
      Credits = Credits.map(credit => {
        return credit.value || credit;
      })
    } else {
      Credits = [];
    }
    Method = Method.value || Method;
    return dispatch => {
      dispatch({ type: EDIT_AP });
      return axios({
        method: 'put',
        url: `${AP_URL}payment/${PaymentID}`,
        data: {
          CheckNum,
          TotalPayment,
          Method,
          PostingDate,
          PaymentDate,
          WaiveAmount,
          Discount,
          Account,
          AccountName,
          Credits,
          Note,
          Invoices,
        },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
      .then(response => {
        dispatch(editAPSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editAPFailure(err));
        }
      });
    };
}

export function editAPSuccess(response) {
    return {
        type: EDIT_AP_SUCCESS,
        payload: response
    };
}

export function editAPFailure(response) {
  return {
      type: EDIT_AP_FAILURE,
      payload: response
  };
}

export function deleteAP(Payment_id) {
  return dispatch => {
      dispatch({type: DELETE_AP});
      return axios.delete(AP_URL + 'payment/' + Payment_id,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(deleteAPSuccess(response));
            browserHistory.push('/AP');
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(deleteAPFailure(err));
            }
          });
  }
}

function deleteAPSuccess(response) {
  return {
    type: DELETE_AP_SUCCESS,
    payload: response
  }
}

function deleteAPFailure(response) {
  return {
    type: DELETE_AP_FAILURE,
    payload: response
  }
}

export function fetchAPInvoices(vendor_id, invoiceDate, fromDate, toDate) {
    const dates = toFromDates(-1, fromDate, toDate);
    if(invoiceDate == "range" && fromDate) {
      fromDate = "PostingDate__gte=" + dates.fromDate + "&";
    }
    else {
      fromDate = ""
    }
    if(invoiceDate == "range" && toDate) {
      toDate = "PostingDate__lte=" + dates.toDate + "&";
    }
    else {
      toDate = ""
    }
    vendor_id = "Vendor_id=" + vendor_id;
    return dispatch => {
        dispatch({type: REQUEST_INVOICES});
        return axios.get(AP_URL + 'invoices/?' + fromDate + toDate + vendor_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchInvoicesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchInvoicesFailure(err));
              }
            });
    }
}

export function fetchAPCredits(vendor_id) {
  return dispatch => {
      dispatch({type: REQUEST_CREDITS});
      return axios.get(AP_URL + 'credits/' + vendor_id,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(fetchCreditsSuccess(response));
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(fetchCreditsFailure(err));
            }
          });
  }
}

export function fetchAPDetail(checkID) {
    return dispatch => {
        dispatch({type: REQUEST_AP_DETAIL});
        return axios.get(AP_URL + 'payment/' + checkID,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchAPDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchAPDetailFailure(err));
              }
            });
    }
}

export function fetchAPDetailSuccess(response) {
    return {
        type: FETCH_AP_DETAIL_SUCCESS,
        payload: response
    }
}

export function fetchAPDetailFailure(response) {
  return {
      type: FETCH_AP_DETAIL_FAILURE,
      payload: response
  }
}

export function clearAPDetail() {
  return {
    type: CLEAR_AP_DETAIL,
  }
}

export function clearAPForm() {
  return {
    type: CLEAR_AP_FORM,
  }
}

export function fetchStatement(CustomerNum, type, StartDate, EndDate) {
    const dates = toFromDates(-1, StartDate, EndDate);
    StartDate = dates.fromDate;
    EndDate = dates.toDate;
    return dispatch => {
        dispatch({type: REQUEST_STATEMENT});
        return axios.post(AR_URL + 'statement/' + type + '/print/',
            {
                CustomerNum,
                StartDate,
                EndDate
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              window.open("data:application/pdf," + escape(response.data));
              dispatch(fetchStatementSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchStatementFailure(err));
              }
            });
    }
}

export function fetchStatementSuccess(response) {
    return {
        type: FETCH_STATEMENT_SUCCESS,
        payload: response
    }
}

export function fetchStatementFailure(response) {
  return {
      type: FETCH_STATEMENT_FAILURE,
      payload: response
  }
}

export function fetchStatementAP(VendorNum, type, StartDate, EndDate) {
    const dates = toFromDates(-1, StartDate, EndDate);
    StartDate = dates.fromDate;
    EndDate = dates.toDate;
    return dispatch => {
        dispatch({type: REQUEST_STATEMENT_AP});
        return axios.post(AP_URL + 'statement/' + type + '/print/',
            {
                VendorNum,
                StartDate,
                EndDate
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              window.open("data:application/pdf," + escape(response.data));
              dispatch(fetchStatementAPSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchStatementAPFailure(err));
              }
            });
    }
}

export function fetchStatementAPSuccess(response) {
    return {
        type: FETCH_STATEMENT_AP_SUCCESS,
        payload: response
    }
}

export function fetchStatementAPFailure(response) {
  return {
      type: FETCH_STATEMENT_AP_FAILURE,
      payload: response
  }
}

export function fetchGeneralReport(type, salesType, typeRadios, fromDate, toDate, state, activeCompany) {
  let params = {
    type: typeRadios,
    start_date: fromDate,
    end_date: toDate,
  };
  if (isAFG) {
    params['state'] = state;
  }
  let url = `${AR_URL}report/${type}/${salesType}/`;
  if (isGGI && activeCompany) {
    url += `?company_id=${activeCompany.value}`
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_GENERAL_REPORT });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    }).then((response) => {
      dispatch(fetchGeneralReportSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchGeneralReportFailure(err));
      }
    });
  }
}

export function fetchGeneralReportSuccess(data) {
  return {
    type: FETCH_GENERAL_REPORT_SUCCESS,
    payload: data
  }
}

export function fetchGeneralReportFailure(error) {
  return {
    type: FETCH_GENERAL_REPORT_FAILURE,
    payload: error
  }
}

export function fetchCityReport({ fromDate, toDate }, selectedCompany) {
  const token = localStorage.getItem('token');
  const dates = toFromDates(-1, fromDate, toDate);
  return dispatch => {
    dispatch({ type: REQUEST_CITY_REPORT });
    if (!selectedCompany.value) return;
    return axios({
      method: 'get',
      url: `${AR_URL}cityreport/?start_date=${dates.fromDate}&end_date=${dates.toDate}&company_id=${selectedCompany.value}`,
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(response => {
      dispatch(fetchCityReportSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchCityReportFailure(err));
      }
    });
  };
}

export function fetchCityReportSuccess(data) {
  return {
    type: FETCH_CITY_REPORT_SUCCESS,
    payload: data,
  };
}

export function fetchCityReportFailure(error) {
  return {
    type: FETCH_CITY_REPORT_FAILURE,
    payload: error,
  };
}

export function resetCityReport() {
  return dispatch => {
    dispatch({ type: RESET_CITY_REPORT });
  };
}

export function fetchCustomerStatement(fromDate, endDate, customerID, statementType, paymentCutoffDate) {
  if (!fromDate) {
    fromDate = new Date(moment().subtract(1000, 'Y').toISOString());
  }
  const token = localStorage.getItem('token');
  const dates = toFromDates(-1, fromDate, endDate);
  const postingDateGT = `start_date=${dates.fromDate}`;
  const postingDateLT = `end_date=${dates.toDate}`;
  const url = `${AR_URL}report/aged/${customerID}/?${postingDateGT}&${postingDateLT}&cut_off_date=${getFromToDates(paymentCutoffDate).toDate}`;
  return dispatch => {
    dispatch({ type: REQUEST_CUSTOMER_STATEMENT });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(response => {
      dispatch(fetchCustomerStatementSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchCustomerStatementFailure(err));
      }
    });
  };
}

export function fetchCustomerStatementSuccess(data) {
  return {
    type: FETCH_CUSTOMER_STATEMENT_SUCCESS,
    payload: data
  }
}

export function fetchCustomerStatementFailure(error) {
  return {
    type: FETCH_CUSTOMER_STATEMENT_FAILURE,
    payload: error
  }
}

export function fetchVendorStatement(fromDate, endDate, vendorID, statementType, paymentCutoffDate) {
  const token = localStorage.getItem('token');
  const dates = toFromDates(-1, fromDate, endDate);
  const postingDateGT = `start_date=${dates.fromDate}`;
  const postingDateLT = `end_date=${dates.toDate}`;
  const url = `${AP_URL}report/aged/${vendorID}/?${postingDateGT}&${postingDateLT}&cut_off_date=${getFromToDates(paymentCutoffDate).toDate}`;
  return dispatch => {
    dispatch({ type: REQUEST_VENDOR_STATEMENT });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(response => {
      dispatch(fetchVendorStatementSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchVendorStatementFailure(err));
      }
    });
  };
}

export function fetchVendorStatementSuccess(data) {
  return {
    type: FETCH_VENDOR_STATEMENT_SUCCESS,
    payload: data
  }
}

export function fetchVendorStatementFailure(error) {
  return {
    type: FETCH_VENDOR_STATEMENT_FAILURE,
    payload: error
  }
}

export function fetchCustomerStatementListSuccess(data) {
  return {
    type: FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS,
    payload: data,
  };
}

export function fetchCustomerStatementListFailure(error) {
  return {
    type: FETCH_CUSTOMER_STATEMENT_LIST_FAILURE,
    payload: error,
  };
}

export function fetchCustomerStatementList(type, date, agedDays, company_id = undefined) {
  const { toDate } = getFromToDates(date);
  return (dispatch) => {
    let params = {
      PostingDate: toDate,
    }
    if (isLAP && agedDays && agedDays !== "daysAll") {
      params.aged_days = agedDays
    }
    if (isGGI && company_id) {
      params.company_id = company_id
    }
    dispatch({ type: REQUEST_CUSTOMER_STATEMENT_LIST });
    return axios({
      method: 'get',
      url: `${AR_URL}statement/show/${type}/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params
    }).then((response) => {
      dispatch(fetchCustomerStatementListSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchCustomerStatementListFailure(err));
      }
    });
  };
}

export function fetchVendorStatementList(type, days, Company_id = undefined) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
      dispatch({type: REQUEST_VENDOR_STATEMENT_LIST});
      let date = moment(days).endOf('day');
      date = date.toISOString();
      let params = { PostingDate: date, Company_id };
      return axios.get(AP_URL +'report/aged/'+ type + "/show/",
          {
              params,
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(fetchVendorStatementListSuccess(response));
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(fetchVendorStatementListFailure(err));
            }
          });
  }
}

export function fetchVendorStatementListSuccess(data) {
  return {
    type: FETCH_VENDOR_STATEMENT_LIST_SUCCESS,
    payload: data
  }
}

export function fetchVendorStatementListFailure(error) {
  return {
    type: FETCH_VENDOR_STATEMENT_LIST_FAILURE,
    payload: error
  }
}


export function fetchMobileCustomerStatement({ fromDate, toDate }, type) {
  const url = `${AR_URL}statement/mobile/show/`;
  return (dispatch) => {
    dispatch({ type: REQUEST_MOBILE_CUSTOMER_STATEMENT });
    const token = localStorage.getItem('token');
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${token}` },
      params: {
        type,
        start_date: fromDate,
        end_date: toDate,
      },
    }).then((response) => {
      dispatch(fetchMobileCustomerStatementSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchMobileCustomerStatementFailure(err));
      }
    });
  };
}

export function fetchMobileCustomerStatementSuccess(data) {
  return {
    type: FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS,
    payload: data,
  };
}

export function fetchMobileCustomerStatementFailure(error) {
  return {
    type: FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE,
    payload: error,
  };
}

export function resetMobileCustomerStatement() {
  return dispatch => {
    dispatch({ type: RESET_MOBILE_CUSTOMER_STATEMENT });
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/arap_actions.jsx